import type { PagesConfig } from '#types/config/pages'

export default {
  brandClasses: {
    eSpotLazyAboveFooter: 'my-16',
    header: 'my-8 text-center container',
    noResultsMessage: 'mt-3',
    noResultsMessageLinks: 'fw-medium'
  },
  defaultSearchTerm: 'Jacket'
} satisfies PagesConfig['search']
